import { put, call, all, fork, select, takeLatest } from "redux-saga/effects";
import { isEmpty } from "lodash";
import {
  expenseReportsListApiUpsellProvider,
  expenseReportsWeeklyApiUpsellProvider,
  expenseRejectTypesApiUpsellProvider,
  usersApiUpsellProvider
} from "./../../../lib/api/providers";
import {
  GET_EXPENSE_REPORTS_WEEKLY,
  GET_EXPENSE_REPORTS_LIST,
  GET_EXPENSE_REPORTS_USER_WEEKLY,
  GET_EXPENSE_REJECT_TYPES,
  GET_USERS_SECTORS
} from "../actions/expenseReports";
import { EXPENSE_REPORTS_IS_LOADING } from "../reducers/expenseReports";

const getLogState = state => state.log;
const getState = state => state;
const getAuthState = state => state.auth || {};

const getExpensesReportsListApi = (endpoint, token, params) => {
  const filters = isEmpty(params) ? { sort: { date: -1 } } : params;

  return endpoint
    .post(`/`, filters, {
      headers: {
        Authorization: token
      }
    })
    .then((response = {}) => {
      return response.data;
    });
};

export function* getExpenseReportsList(action) {
  try {
    yield put({ type: EXPENSE_REPORTS_IS_LOADING, payload: true });
    const stateAuth = yield select(getAuthState);
    const state = yield select(getLogState);
    const values = yield call(
      getExpensesReportsListApi,
      expenseReportsListApiUpsellProvider,
      stateAuth.token,
      action.payload
    );

    yield put({
      type: "SET_EXPENSE_REPORTS_LIST",
      payload: values
    });
    // yield put({ type: LOG_FILTERS_LOADING, loading: false });
  } catch (e) {
    console.log(e.message);
    // yield put({ type: LOG_FILTERS_LOADING, loading: false });
  } finally {
    yield put({ type: EXPENSE_REPORTS_IS_LOADING, payload: false });
  }
}

export function* getExpenseReportsWeekly(action) {
  try {
    yield put({ type: EXPENSE_REPORTS_IS_LOADING, payload: true });
    const stateAuth = yield select(getAuthState);
    const state = yield select(getLogState);
    const values = yield call(
      getExpensesReportsListApi,
      expenseReportsWeeklyApiUpsellProvider,
      stateAuth.token,
      action.payload
    );

    yield put({
      type: "SET_EXPENSE_REPORTS_WEEKLY",
      payload: values
    });
  } catch (e) {
    console.log(e.message);
  } finally {
    yield put({ type: EXPENSE_REPORTS_IS_LOADING, payload: false });
  }
}

export function* getExpenseReportsUserWeekly(action) {
  try {
    yield put({ type: EXPENSE_REPORTS_IS_LOADING, payload: true });
    const stateAuth = yield select(getAuthState);
    const state = yield select(getLogState);
    const values = yield call(
      getExpensesReportsListApi,
      expenseReportsWeeklyApiUpsellProvider,
      stateAuth.token,
      action.payload
    );

    yield put({
      type: "SET_EXPENSE_REPORTS_USER_WEEKLY",
      payload: values
    });
  } catch (e) {
    console.log(e.message);
  } finally {
    yield put({ type: EXPENSE_REPORTS_IS_LOADING, payload: false });
  }
}

export function* getExpenseRejectTypes() {
  try {
    const stateAuth = yield select(getAuthState);
    const state = yield select(getLogState);
    const values = yield call(getExpensesReportsListApi, expenseRejectTypesApiUpsellProvider, stateAuth.token);

    yield put({
      type: "SET_EXPENSE_REJECT_TYPES",
      payload: values
    });
  } catch (e) {
    console.log(e.message);
  }
}

export function* getUsersSectors(action) {
  try {
    const stateAuth = yield select(getAuthState);
    const values = yield call(getExpensesReportsListApi, usersApiUpsellProvider, stateAuth.token, action.payload);

    if (values) {
      yield put({
        type: "SET_USERS_SECTORS",
        payload: values
      });
    }
  } catch (e) {
    console.log(e.message);
  }
}

function* watchFecthExpenseReportsList() {
  yield takeLatest(GET_EXPENSE_REPORTS_LIST, getExpenseReportsList);
}

function* watchFetchExpenseReportsWeekly() {
  yield takeLatest(GET_EXPENSE_REPORTS_WEEKLY, getExpenseReportsWeekly);
}

function* watchFetchExpenseReportsUserWeekly() {
  yield takeLatest(GET_EXPENSE_REPORTS_USER_WEEKLY, getExpenseReportsUserWeekly);
}

function* watchFetchExpenseRejectTypes() {
  yield takeLatest(GET_EXPENSE_REJECT_TYPES, getExpenseRejectTypes);
}

function* watchFetchUsersSectors() {
  yield takeLatest(GET_USERS_SECTORS, getUsersSectors);
}

export default function* root() {
  yield all([
    fork(watchFecthExpenseReportsList),
    fork(watchFetchExpenseReportsWeekly),
    fork(watchFetchExpenseReportsUserWeekly),
    fork(watchFetchExpenseRejectTypes),
    fork(watchFetchUsersSectors)
  ]);
}



// WEBPACK FOOTER //
// src/modules/presence/sagas/expenseReportsSagas.js